import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@material-ui/core/Button';

import ArrowRightIcon from 'mdi-material-ui/ArrowRight';
import ArrowLeftIcon from 'mdi-material-ui/ArrowLeft';

class GuidePagination extends React.PureComponent {
  getCurrentChapter(chapters, currentUID) {
    let chapterIndex = chapters.findIndex(
      chapter => chapter.uid === currentUID
    );
    return {
      number: chapterIndex + 1,
      index: chapterIndex,
      first: chapterIndex === 0,
      last: chapterIndex === chapters.length
    };
  }

  render() {
    const { chapters, currentUID } = this.props;
    const currentChapter = this.getCurrentChapter(chapters, currentUID);
    const nextChapter = chapters[currentChapter.index + 1];
    const prevChapter = chapters[currentChapter.index - 1];

    return (
      <Fragment>
        {!currentChapter.last &&
          nextChapter && (
            <Button
              size="large"
              color="primary"
              component={Link}
              to={nextChapter.url}
              fullWidth
              disableRipple
            >
              To Chapter {currentChapter.number + 1} <ArrowRightIcon />
            </Button>
          )}

        {!currentChapter.first &&
          prevChapter && (
            <Button
              size="large"
              component={Link}
              to={prevChapter.url}
              fullWidth
              disableRipple
            >
              <ArrowLeftIcon /> To Chapter {currentChapter.number - 1}
            </Button>
          )}
      </Fragment>
    );
  }
}

GuidePagination.propTypes = {
  chapters: PropTypes.array,
  currentUID: PropTypes.string
};

export default GuidePagination;
